import { render } from "./FullscreenSpin.vue?vue&type=template&id=5e77feb8&scoped=true&ts=true"
import script from "./FullscreenSpin.vue?vue&type=script&lang=ts"
export * from "./FullscreenSpin.vue?vue&type=script&lang=ts"

import "./FullscreenSpin.vue?vue&type=style&index=0&id=5e77feb8&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e77feb8"]])

export default __exports__